import { Vue, Component, Prop } from 'vue-property-decorator';
import { SiteEquipmentsCustomerListItemDTO } from '@/../client-generator/generated-clients/siteEquipments';

@Component({})
export default class SiteEquipmentsListCardsComponent extends Vue {
  @Prop() siteEquipments!: SiteEquipmentsCustomerListItemDTO[];
}
